// extracted by mini-css-extract-plugin
export default {"sectionTitle":"SectionTitle_sectionTitle__Dg20Z"};